import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import payment from "../images/payment-icons.png";
import { BASE_URL } from '../config';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { shallowEqual, useSelector } from 'react-redux';
import { FaFacebookF,FaLinkedinIn,FaYoutube } from "react-icons/fa";
function Footer() {
    let navigate = useHistory();
    const [data,setData]=useState();
    const [year,setYear]=useState();
    const state = useSelector(
      (state) => (
         state.dataReducer
      ),
      shallowEqual
    );
    let goFacebook=(e,url)=>{
      e.preventDefault();
      console.log(url)
      window.open(`${data.facebook_link}`,'_blank', 'noopener,noreferrer')
    }
    let goLinkdin=(e)=>{
e.preventDefault();
window.open(`${data.linkedin_link}`,'_blank', 'noopener,noreferrer')
    };
    let goYoutube=(e)=>{
      e.preventDefault();
      window.open(`${data.youtube_link}`,'_blank', 'noopener,noreferrer')
    }
    useEffect(() => {
      setData(state.settingData);
      }, [state])

      
useEffect(()=>{
  const d = new Date();
  let year = d.getFullYear();
  setYear(year)
},[])
  return (
    <footer className="footercontainer">
  <div className="container">
    <div className="row">
      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 d-none d-lg-block">
        <div className="footerlt">
          <div className="footerlogo">
            <a href="/" onClick={(e)=>{e.preventDefault(); navigate.push("/")}}>
             { data&&<img src={`${BASE_URL}/${data?.footer_image}`} alt=""/>}
              </a>
          </div>   
          <div className="d-none d-lg-block">
            <div className="weaccept">
              <h4>We Accept</h4>
              {/* <img src={payment} alt="Payment"/> */}
              <LazyLoadImage
      alt={"Payment"}
      src={payment} // use normal <img> attributes as props
      width={275}
      height={37}
       />
            </div>  
            <div className="copyright">Copyright &copy; {year}  <a href="/" onClick={(e)=>{e.preventDefault(); navigate.push("/")}}>CNC Machine.</a>All Rights Reserved.</div> 
          </div>
        </div>
      </div>
      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
        <div className="footernav">
          <h3>Sitemap</h3>
          <ul>
            <li><a href="/" onClick={(e)=>{e.preventDefault(); navigate.push("/")}}>Home</a></li>
            <li><a href="/about-me" onClick={(e)=>{e.preventDefault();navigate.push("/about-me")}}>About Us</a></li>
            <li><a href="/course" onClick={(e)=>{e.preventDefault();navigate.push("/course")}}>Course</a></li>
            <li><a href="/contact-us" onClick={(e)=>{e.preventDefault();navigate.push("/contact-us")}}>Contact Us</a></li>                                    
            <li><a href="/faq" onClick={(e)=>{e.preventDefault();navigate.push("/faq")}}>FAQs</a></li>                                                                   
            <li><a href="/terms-conditions" onClick={(e)=>{e.preventDefault();navigate.push("/terms-conditions")}}>Terms and Conditions</a></li>                                                                   
            <li><a href="/privacy-policy" onClick={(e)=>{e.preventDefault();navigate.push("/privacy-policy")}}>Privacy Policy</a></li>                                                                   
          </ul>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-5 col-sm-6 col-12">
        <div className="addressbx">
          <h3>Contact Us</h3>
          <div className="p-0">
            <div className="row">
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="addresst addresstext">
                  <i className="icon icon-map-marker"></i>
                  <h4>Address</h4>
                  <p>{data?.site_address}</p>
                </div>
              </div>
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="addresst emailbx" >
                  <i className="icon icon-envelope"></i>
                  <h4>Email</h4>
                  <p style={{fontSize:"13px"}}><a style={{whiteSpace:"nowrap"}} href={`mailto:${data?.footer_email?.split("/")[0]}`}>{data?.footer_email?.split("/")[0]}</a></p>
                  <p style={{marginTop:"-1vh"}}><a href={`mailto:${data?.footer_email?.split("/")[1]}`}>{data?.footer_email?.split("/")[1]}</a></p>
                </div>
              </div>
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="addresst phonebx">
                  <i className="icon icon-phone"></i>
                  <h4>Phone</h4>
                  <p><a href={`tel:${data?.site_phone_number}`}>{data?.site_phone_number}</a></p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12">
        <div className="footersocialouter">
          <h3>Follow Us On</h3>
          <div className="footersocial">
            <a className="facebook" href={data?.facebook_link} onClick={(e)=>goFacebook(e,data?.facebook_link)}>
              {/* <i className="fa fa-facebook"></i> */}
              <i><FaFacebookF/></i>
              <span></span><em>Facebook</em></a>
            <a className="linkedin" href={data?.linkedin_link} onClick={goLinkdin}>
              {/* <i className="fa fa-linkedin"></i> */}
              <i><FaLinkedinIn/></i>
              <span></span><em>Linkedin</em></a>
            <a className="youtube" href={data?.youtube_link} onClick={goYoutube}>
              {/* <i className="fa fa-youtube-play"></i> */}
              <i>
                <FaYoutube/>
              </i>
              <span></span><em>YouTube</em></a>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-12">
        <div className="mcopyright">
          <div className="weaccept">
            <h4>We Accept</h4>
            {/* <img src="images/payment-icons.png" alt="Payment"/> */}
            <LazyLoadImage
      alt={"Payment"}
      // height={491}
      src={payment} // use normal <img> attributes as props
      // width={1296}
       />
          </div>  
          <div className="copyright">Copyright &copy; {year} <a href="/" onClick={(e)=>{e.preventDefault(); navigate.push("/")}}>CNC Machine.</a>All Rights Reserved.</div> 
        </div>
      </div>
    </div>
  </div>
</footer>
  )
}

export default Footer